<div class="container">
  <div>
    <p class="goback"> <i class="bi bi-arrow-left" (click)="goBack()"></i> Back to Appointments</p>
  </div>
</div>

<!-- PayInfo Cards -->
<div class="summary-cards">
  <div class="summary-card green">
    <div class="icon-circle green-bg">
      <i class="bi bi-check2-circle"></i>
    </div>
    <div>
      <p class="label">Total Paid</p>
      <h3 class="value">₹{{ getTotalPaid() | number:'1.0-0' }}</h3>
    </div>
  </div>

  <div class="summary-card red">
    <div class="icon-circle red-bg">
      <i class="bi bi-arrow-repeat"></i>
    </div>
    <div>
      <p class="label">Refunded</p>
      <h3 class="value">₹{{ getTotalRefunded() | number:'1.0-0' }}</h3>
    </div>
  </div>

  <div class="summary-card yellow">
    <div class="icon-circle yellow-bg">
      <i class="bi bi-clock-history"></i>
    </div>
    <div>
      <p class="label">Refund Initiated</p>
      <h3 class="value">₹{{ getTotalRefundInitiated() | number:'1.0-0' }}</h3>
    </div>
  </div>

  <div class="summary-card blue">
    <div class="icon-circle blue-bg">
      <i class="bi bi-bar-chart"></i>
    </div>
    <div>
      <p class="label">Total Transactions</p>
      <h3 class="value">{{ getTotalTransactions() }}</h3>
    </div>
  </div>
</div>
<!-- PayInfo Cards -->

<div class="calendar-container">
  <!-- Listing payments -->
  <div class="appointments-container">
    <div class="top-bar">
      <!-- Search -->
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search payments..." [(ngModel)]="searchQuery" (input)="onSearchChange()" />
      </div>
      <!-- Search -->

      <!-- Filters -->
      <div class="filter-group">
        <div class="filter-item dropdown">
          <i class="bi bi-funnel"></i>
           <select [(ngModel)]="statusFilter" (change)="onStatusChange(statusFilter)">
              <option value="all">All Status</option>
              <option value="paid">Paid</option>
              <option value="refunded">Refunded</option>
              <option value="refund_initiated">Refund Initiated</option>
            </select>
        </div>

        <div class="filter-item dropdown">
          <i class="bi bi-person"></i>
          <select [(ngModel)]="statusLawyer" (change)="onLawyerChange(statusLawyer)">
            <option *ngFor="let lawyer of lawyerOptions" [value]="lawyer">{{ lawyer }}</option>
          </select>
        </div>

        <div class="filter-item dropdown">
          <i class="bi bi-sort-down"></i>
          <select [(ngModel)]="sortBy" (change)="applyFilters()">
            <option value="">Latest First</option>
            <option value="date">Oldest First</option>
            <option value="name">By Name</option>
          </select>
        </div>
      </div>
      <!-- Filters -->
    </div>

    <!-- List of Appointments -->
    <div class="appointments-list">
      <div class="list-header">
        <h3 style="font-weight: 600;">Payment History ({{ filteredAppointments.length }})</h3>
      </div>

      <!-- Loading Indicator -->
      <div *ngIf="isLoading" class="loading-container" style="text-align: center; padding: 40px;">
        <p>Loading appointments...</p>
      </div>

      <!-- List View -->
      <div class="table-view" *ngIf="!isLoading">
        <div class="table-scroll">
        <table mat-table [dataSource]="pagedAppointments" class="appointments-table">

          <!-- Lawyer Name -->
          <ng-container matColumnDef="lawyer">
            <th mat-header-cell *matHeaderCellDef (click)="sortByColumn('lawyer')" style="cursor:pointer">
              Lawyer Name
              <!-- Shows desc icon when sorted desc by lawyer, default icon otherwise -->
              <img class="sortarr"
                [src]="sortColumn === 'lawyer' && sortDirection === 'desc'
                  ? 'assets/icons/sortarr-desc.svg'
                  : 'assets/icons/sortarr.svg'"/>
            </th>
            <td mat-cell *matCellDef="let a">
              <div class="lawyer-cell">
                <div class="avatar-wrapper">
                  <!-- Show Image if exists -->
                  <img *ngIf="a.lawyer_profile_pic; else initialsAvatar"
                      [src]="a.lawyer_profile_pic"
                      alt="Lawyer"
                      class="profile-img" />

                  <!-- Fallback to initials -->
                  <ng-template #initialsAvatar>
                    <div class="avatar small">{{ a.lawyerInitials }}</div>
                  </ng-template>
                </div>
                <div>
                  <div class="name">{{ a.lawyerName }}</div>
                  <div class="spec">{{ a.specialization }}</div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Date & Time -->
          <ng-container matColumnDef="datetime">
            <th mat-header-cell *matHeaderCellDef (click)="sortByColumn('date')" style="cursor:pointer">
              Appointment Date
              <!--
                FIX 1: Was using [style.transform] rotate trick (leftover from old code) which
                never swapped the icon src. Now correctly checks sortColumn === 'date'.
              -->
              <img class="sortarr"
                [src]="sortColumn === 'date' && sortDirection === 'desc'
                  ? 'assets/icons/sortarr-desc.svg'
                  : 'assets/icons/sortarr.svg'"/>
            </th>
            <td mat-cell *matCellDef="let a">
              <div class="datetime">
                <ng-container *ngIf="a.note; else showDate">
                  {{ a.note }}
                </ng-container>
                <ng-template #showDate>
                  {{ a.dateTime | date: 'EEE, MMM dd, h:mm a' }}
                </ng-template>
              </div>
            </td>
          </ng-container>

          <!-- Amount Paid -->
          <ng-container matColumnDef="features">
            <th mat-header-cell *matHeaderCellDef (click)="sortByColumn('amount')" style="cursor:pointer">
              Amount Paid
              <!--
                FIX 2: sortByColumn('amount') now sets sortColumn to 'amount' and applyFilters()
                has an explicit amount sort block — so this binding correctly shows the active icon.
              -->
              <img class="sortarr"
                [src]="sortColumn === 'amount' && sortDirection === 'desc'
                  ? 'assets/icons/sortarr-desc.svg'
                  : 'assets/icons/sortarr.svg'"/>
            </th>
            <td mat-cell *matCellDef="let a" class="features-cell">
              <div class="name" [ngClass]="{ scheduled: a.amount }">&#8377; {{ a.amount }}</div>
            </td>
          </ng-container>

          <!-- Method -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Method </th>
            <td mat-cell *matCellDef="let a">
              <span>{{ a.subStatus || 'N/A' }}</span>
            </td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let a">
              <span class="status-tag"
                    [ngClass]="{
                      paid: a.status === 'Paid',
                      refunded: a.status === 'Refunded',
                      'refund-initiated': a.status?.toLowerCase() === 'refund_initiated'
                    }">
                {{ a.status }}
              </span>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-cell"></th>
            <td mat-cell *matCellDef="let a" class="actions-cell">
              <span class="action-btn-wrapper"
                    [matTooltip]="a.appointment_status === 'cancelled' ? 'Invoice unavailable: This appointment was cancelled and the payment has been refunded' : ''"
                    [matTooltipDisabled]="a.appointment_status !== 'cancelled'"
                    matTooltipPosition="left">
                <button mat-icon-button
                        [disabled]="a.appointment_status === 'cancelled'"
                        [matMenuTriggerFor]="paymentActionMenu">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
              </span>
              <mat-menu #paymentActionMenu="matMenu">
                <button mat-menu-item (click)="viewInvoice(a)">
                  <i class="bi bi-eye"></i>
                  <span>View Invoice</span>
                </button>
                <button mat-menu-item (click)="downloadInvoice(a)">
                  <i class="bi bi-download"></i>
                  <span>Download Invoice</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        </div>

        <!-- Empty State -->
        <div *ngIf="pagedAppointments.length === 0" style="text-align: center; padding: 40px;">
          <p>No appointments found</p>
        </div>

        <!-- Pagination -->
        <div class="pagination" *ngIf="pagedAppointments.length > 0">
          <span class="pagination-info-text">
            {{ (pageIndex * pageSize) + 1 }} - {{ endIndex }} of {{ filteredAppointments.length }} items
          </span>
          <div class="pagination-buttons">
            <button class="page-btn" [disabled]="pageIndex === 0" (click)="prevPage()">
              <i class="bi bi-chevron-left"></i> Previous
            </button>
            <button class="page-btn" [disabled]="(pageIndex + 1) * pageSize >= filteredAppointments.length" (click)="nextPage()">
              Next <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
        <!-- Pagination -->

      </div>
    </div>
  </div>
  <!-- Listing payments -->
</div>

<!-- Shared invoice PDF viewer (see invoice-pdf-viewer.component.ts for why this
     is a separate small component instead of the Documents module's viewer) -->
<app-invoice-pdf-viewer
  [isOpen]="isInvoicePreviewOpen"
  [isLoading]="isInvoicePreviewLoading"
  [previewUrl]="invoicePreviewUrl"
  [title]="invoiceTitle"
  (closed)="closeInvoicePreview()">
</app-invoice-pdf-viewer>